<template>
  <v-layout style="height: 100%" @click="timer > 0 ? timer = timerDefault : ''">
    <v-flex xs12 md6 offset-md3>
      <v-card height="100%">
        <v-container fluid>
          <p class="caption text-xs-right" v-if="timer > 0">Auto signout in {{ logoutCountdown }}</p>
          <p class="headline text-xs-center">Welcome {{ fullname }}</p>
          <template v-if="modules.pod2 === 1">
            <!-- <v-btn :disabled="clockedIn" color="primary" to="/podJobs" block large round>
              <v-icon x-large>assignment</v-icon> View Your Tasks
            </v-btn> -->
            <hr>
          </template>
          <v-layout row wrap grid-list-xs class="text-xs-center" justify-center>
            <v-flex xs3 v-if="modules.expenses === 1">
              <v-card flat>
                <v-btn color="primary" to="/Expenses" large flat icon>

                  <v-icon x-large>mdi-receipt-text</v-icon>
                </v-btn>
                <p class="text-xs-center">Receipt Capture</p>
              </v-card>
            </v-flex>
            <v-flex xs3 v-if="modules.viewexpenses === 1 && showExpenses === '1'">
              <v-card flat>
                <v-btn color="primary" to="/ViewExpenses" large flat icon>
                  <v-icon x-large>mdi-receipt-text-clock</v-icon>
                </v-btn>
                <p class="text-xs-center">View Expenses</p>
              </v-card>
            </v-flex>
            <v-flex xs3 v-if="modules.pod === 1">
              <v-card flat>
                <v-btn :disabled="clockedIn" color="purple darken-2" @click="loadDialog = true" large flat icon>
                  <v-icon x-large>local_shipping</v-icon>
                </v-btn>
                <p class="text-xs-center">Add Additional Loads</p>
              </v-card>
            </v-flex>
            <v-flex xs3 v-if="modules.jobEntry === 1">
              <v-card flat>
                <v-btn :disabled="clockedIn || loadingTimeline" color="purple darken-2" :to="'/JobDetails/' + taId + '/1/' +  (jobStarted ? latestJobId : -1)"  large flat icon>
                  <v-icon x-large>assignment</v-icon>
                </v-btn>
                <p class="text-xs-center">{{ !jobStarted ? 'Start New Job' : 'End Job' }}</p>
              </v-card>
            </v-flex>
            <v-flex xs3 v-if="modules.timesheets === 1">
              <v-card flat>
                <v-btn :disabled="!clockedIn" color="green darken-2" to="/TimesheetEntry/in" large flat icon>
                  <v-icon x-large>file_download</v-icon>
                </v-btn>
                <p class="text-xs-center">Clock In</p>
              </v-card>
            </v-flex>
            <v-flex xs3 v-if="modules.timesheets === 1">
              <v-card flat>
                <v-btn :disabled="clockedIn || (modules.jobEntry === 1 && (jobStarted || !anyJobsInShift))" color="red darken-2"
                  to="/TimesheetEntry/out" large flat icon>
                  <v-icon x-large>file_upload</v-icon>
                </v-btn>
                <p class="text-xs-center">Clock Out</p>
              </v-card>
            </v-flex>
            <v-flex xs3 v-if="$store.getters.user.modules.holrequest == 1">
              <v-card flat>
                <v-btn color="orange darken-2" to="/HolidayRequest" large flat icon>
                  <v-icon x-large>work</v-icon>
                </v-btn>
                <p class="text-xs-center">Holiday Request</p>
              </v-card>
            </v-flex>
            <v-flex xs3 v-if="$store.getters.user.modules.Schengen == 1">
              <v-card flat>
                <v-btn color="blue darken-2" to="/SchengenTrips" large flat icon>
                  <v-icon x-large>mdi-earth</v-icon>
                </v-btn>
                <p class="text-xs-center">Schengen Trips</p>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-show="!timelineFailed && loadingTimeline && modules.jobEntry === 1">
            <v-flex xs-12 class="text-xs-center">
              <v-progress-circular class="ma-5" :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-show="timelineFailed && modules.jobEntry === 1">
            <v-flex xs-12 class="text-xs-center ms-3 mb-4 pa-4 elevation-10">
              <div class="title">Failed to load timeline</div>
              <div class="subheading">Check your connection and try again</div>
            </v-flex>
          </v-layout>
          <v-subheader v-if="savedJobData.length > 0 && modules.jobEntry === 1 && !loadingTimeline && !clockedIn">Jobs
            Completed In Current Shift</v-subheader>
          <v-timeline align-top dense
            v-if="savedJobData.length > 0 && modules.jobEntry === 1 && !loadingTimeline && !clockedIn">
            <v-timeline-item v-for="(job, p) in savedJobData" :color="job.end_time == null ? 'green' : 'grey'" small
              :key="p">
              <v-layout pt-2>
                <v-flex align-center>
                  <div class="subheading"><strong>{{ job.start_time|formatDate}} - {{job.end_time|formatDate}}</strong></div>
                  <div class="subheading">{{ job.start_time | filterJobTime }}-{{ job.end_time | filterJobTime }}
                  </div>
                  <div class="caption">{{ job|formattedJobLength }}</div>
                  <div>
                    <div class="body-1">{{ job.farm_name }}</div>
                    <div class="caption">{{ job.job_desc_name }} {{ job.product_name }}</div>
                    <div :key="p" class="caption" v-if="job.spray_bonus != null">{{ job.spray_bonus }} Hectares</div>
                  </div>
                </v-flex>
                <v-flex justify-end shrink v-if="job.end_time !== null">
                  <v-btn color="primary" flat icon :to="'/JobDetails/' + taId + '/1/' + job.job_id">
                    <v-icon medium>mode_edit</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-timeline-item>
          </v-timeline>

          <v-alert :v-model="timesheetData.length < 1" type="info" v-if="modules.timesheets === 1">No Recent
            Shifts</v-alert>
          <v-list v-if="timesheetData.length > 0 && modules.timesheets === 1" subheader three-line dark>
            <v-subheader>Recent Shifts</v-subheader>
            <v-list-tile v-for="(shift, i) in timesheetData" v-bind:key="i">
              <v-list-tile-content>
                <v-list-tile-title><strong class="grey--text text--darken-1">IN:</strong> {{ shift.start |
                  formatDateTime }}</v-list-tile-title>
                <v-list-tile-title><strong class="grey--text text--darken-1">OUT:</strong> {{ shift.end |
                  formatDateTime }}</v-list-tile-title>
                <v-list-tile-title v-if="shift.penalty" style="min-height: fit-content;">
                <strong class="grey--text text--darken-1">{{ penaltyName }}:</strong> {{ shift.penalty | formatTime }}
                <v-btn icon dense @click="showPenaltyReason(shift.penalty_reason)" style="margin: 0">
                  <v-icon>mdi-information</v-icon>
                </v-btn>
              </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action v-if="shift.end !== undefined && modules.expenses === 1">
                <div>
                  <v-btn icon ripple :to="'/Expenses/' + shift.id">
                    <v-badge left overlap color="green">
                      <v-icon slot="badge" dark small>add</v-icon>
                      <v-icon color="grey darken-1" medium>
                        receipt
                      </v-icon>
                    </v-badge>
                  </v-btn>
                </div>
              </v-list-tile-action>
              <v-list-tile-action v-if="modules.jobEntry === 1 && shift.end !== undefined">
                  <v-btn icon ripple :to="'/JobOverview/' + shift.id">
                    <v-icon color="grey darken-1" medium>
                        assignment
                    </v-icon>
                  </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-layout row>
            <v-flex xs12>
              <Notice-Alert></Notice-Alert>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
    <v-snackbar v-model="snackbar" :timeout="snackbarTimeout">
      {{ snackbarText }}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <Add-Load-Dialog :showDialog="loadDialog" @closeLoadDialog="loadDialog = false" :taId="taId"></Add-Load-Dialog>
    <!-- <Update-Job-Dialog :showDialog="showUpdateJobDialog" :jobObj="selectedJobObj" @closeUpdateJobDialog="showUpdateJobDialog = false" class="mb-4"></Update-Job-Dialog> -->
    <v-dialog
      v-model="penaltyDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{penaltyName}} Reason
        </v-card-title>

        <v-card-text>
          {{ penaltyReason }}  
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="penaltyDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <GlobalMessage :showDialog="showGlobalMessage" @closeDialog="showGlobalMessage = false"></GlobalMessage>
  </v-layout>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import GlobalMessage from './GlobalMessage.vue'
export default {
  data () {
    return {
      snackbar: false,
      snackbarText: '',
      currentJob: false,
      snackbarTimeout: 1000,
      loadDialog: false,
      company: this.$store.getters.company,
      timer: this.$store.getters.signoutInterval * 60,
      timerDefault: this.$store.getters.signoutInterval * 60,
      defaultModules: { timesheets: 1, expenses: 1, viewexpenses: 1, pod: 0, holrequest: 1 },
      jobStarted: false,
      anyJobsInShift: false,
      savedJobData: [],
      url: this.$store.getters.url,
      standardShiftDetails: [],
      taSettings: [],
      timelineFailed: false,
      loadingTimeline: false,
      emp: this.$store.getters.user,
      showExpenses: null,
      dialogVisible: false,
      showGlobalMessage: true,
      penaltyDialog: false,
      penaltyReason: '',
      penaltyName: ''
    }
  },
  created () {
    this.getViewExpensesSetting()
    this.$store.dispatch('fetchTimesheet')
    if (this.$store.getters.company.toLowerCase() === 'freshlinc') {
      this.$store.dispatch('setApplicationMode', 'tanda')
      localStorage.setItem('applicationMode', 'tanda')
      this.defaultModules.pod = 1
    }
    if (this.$store.getters.company.toLowerCase() === 'lfp') {
      this.$store.dispatch('setApplicationMode', 'tanda')
      localStorage.setItem('applicationMode', 'tanda')
      this.modules.jobEntry = localStorage.getItem('jobRecording') * 1
    }
    if (this.$store.getters.company.toLowerCase() === 'aquahaulage') {
      this.modules.jobEntry = localStorage.getItem('jobRecording') * 1
    }
    if (this.$store.getters.company.toLowerCase() === 'aquashow') {
      this.defaultModules.pod2 = 1
    }
    this.$store.dispatch('setModules', this.defaultModules)
  },

  mounted () {
    this.$store.dispatch('checkLoginTime')
    if (this.timer > 0) {
      let interval = setInterval(() => {
        this.timer--
        if (this.timer === 0) {
          this.$store.dispatch('logout')
          clearInterval(interval)
        }
      }, 1000)
    }

    this.getPenaltyNameSetting()
    this.getTASettings()
  },
  methods: {
    getTASettings () {
      axios.post(this.url + `/tanda-service/getTASettings.ajax.php`, {
        company: this.company
      })
        .then(response => {
          this.taSettings = response.data
          this.$store.dispatch('setTASettings', response.data)
        })
        .catch(e => {
          console.log(e)
        })
    },
    getPenaltyNameSetting () {
      axios.post(this.url + `/tanda-service/getPenaltyNameSetting.ajax.php`, {
        company: this.company
      })
        .then(response => {
          this.penaltyName = response.data[0].value
        })
        .catch(e => {
          console.log(e)
        })
    },
    showPenaltyReason (reason) {
      this.penaltyReason = reason
      this.penaltyDialog = true
    },
    zeroFill (number, width) {
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return number
    },
    getViewExpensesSetting () {
      axios.post(this.url + `/tanda-service/getShowExpensesSetting.ajax.php`, {
        company: this.company
      })
        .then(response => {
          this.showExpenses = response.data[0].value
        })
        .catch(e => {
          console.log(e)
        })
    },
    getCurrentJobDetails (clockedIn, id) {
      if (!clockedIn && id.length > 0) {
        this.loadingTimeline = true
        this.timelineFailed = false
        axios.post(this.url + `/tanda-service/getCurrentJobList.ajax.php`, {
          company: this.company,
          type: 'all',
          ta_id: id,
          currentJobID: -1
        })
          .then(response => {
            console.log(response)
            this.jobStarted = false
            this.savedJobData = response.data.jobDetails
            this.anyJobsInShift = response.data.jobDetails.length > 0
            for (let job in response.data.jobDetails) {
              let currentJob = response.data.jobDetails[job]
              currentJob.start_time = moment.utc(currentJob.start_time, 'YYYY-MM-DD HH:mm:ss').local().format()
              if (currentJob.end_time == null) {
                this.jobStarted = true
                this.latestJobId = currentJob.job_id
              } else {
                currentJob.end_time = moment.utc(currentJob.end_time, 'YYYY-MM-DD HH:mm:ss').local().format()
              }
            }

            this.savedJobData.sort((a, b) => new Date(b.start_time) - new Date(a.start_time))
            this.loadingTimeline = false
            if (this.anyJobsInShift) {
              let latestJobTime = this.savedJobData[0].end_time
              sessionStorage.setItem('latestJobEndTime', latestJobTime)
            }
          })
          .catch(e => {
            this.timelineFailed = true
            console.log(e)
          })
      }
    }
  },
  computed: {
    modules () {
      return this.$store.getters.user.modules
    },
    fullname () {
      return this.$store.getters.user ? this.$store.getters.user.fname + ' ' + this.$store.getters.user.sname : ''
    },
    timesheetData () {
      let timesheetData = [...this.$store.getters.timesheet]
      return timesheetData.reverse().splice(0, 5)
    },
    taId () {
      let output = this.timesheetData[0] && this.timesheetData[0]['id'] ? this.timesheetData[0]['id'] : ''
      if ((output !== '' || output !== null) && this.modules.jobEntry === 1) {
        let clockedIn = this.clockedIn
        this.getCurrentJobDetails(clockedIn, output)
      }
      return output
    },
    clockedIn () {
      if (this.timesheetData[0] !== undefined) {
        return this.timesheetData[0].end !== undefined
      } else {
        return true
      }
    },
    logoutCountdown () {
      let d = this.timer
      d = Number(d)
      var h = this.zeroFill(Math.floor(d / 3600), 2)
      var m = this.zeroFill(Math.floor(d % 3600 / 60), 2)
      var s = this.zeroFill(Math.floor(d % 3600 % 60), 2)

      return h + ':' + m + ':' + s
    }
  },
  filters: {
    formattedJobLength (job) {
      if (job.end_time === null || job.end_time === undefined) {
        return ''
      }
      let hrs = moment(job.end_time).diff(moment(job.start_time), 'hours')
      let mins = moment(job.end_time).diff(moment(job.start_time), 'minutes') % 60
      return `${hrs}h ${mins}m`
    },
    formatDate (val) {
      return (val !== undefined && val !== null) ? moment(val, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
    },
    formatDateTime (val) {
      return (val !== undefined && val !== null) ? moment(val, 'YYYY-MM-DD HH:mm:ss.SSS').format('DD/MM/YYYY HH:mm') : '--'
    },
    filterJobTime (val) {
      if (val == null) {
        return ''
      }
      return moment(val).format('HH:mm')
    },
    formatTime (val) {
      if (val == null) {
        return ''
      }
      return moment.utc().startOf('day').add(val, 'minutes').format('HH:mm')
    }
  },
  components: {
    GlobalMessage
  }

}
</script>


// WEBPACK FOOTER //
// src/components/Hello.vue